import React from 'react'
import BaseComponent from "../pages/base/BaseComponent";
import {Button, ButtonGroup, Col, Modal, Row, Table} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label"
import Endpoint from "enqc-utilities/src/api/Endpoint";
import {isEmpty, isResponseOk, parseDate} from "enqc-utilities/src/utils/Utilities";
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSave, faWindowClose} from "@fortawesome/free-solid-svg-icons";
import {withRouter} from 'react-router-dom';
import {DD_MMMM_YYYY_HH_MM_SS} from "../utils/Global";
import {ON_PROGRESS} from "enqc-utilities/src/utils/Global";

class ContinueAssemblyConfirmationModal extends BaseComponent{


    constructor(props) {
        super(props);
        let {show, model, assembly} = this.props
        if(isEmpty(model)){
            model = {}
        }
        this.state = {
            show:show,
            model:model,
            reference:"",
        }
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(nextProps!=this.props){
            let {show, reference, model, assembly} = nextProps
            this.setState({show, reference, model, assembly}, () => {
                if(show){
                    // window.history.pushState({ show: true }, '');
                    this.handlePopState = (event) =>{
                        if (show) {
                            this.props.onClose()
                            // window.history.pushState(null, ''); // re-push state to prevent deep back
                            window.history.pushState({ show: true }, '');
                        }
                    }
                    window.addEventListener('popstate', this.handlePopState);
                }else{
                    window.removeEventListener('popstate', this.handlePopState);
                }
            })
        }
    }

    async submit(){
        let {reference, model, assembly} = this.state
        this.showPostProgress()
        this.post(Endpoint.API.UPDATE_ASSEMBLY+"?assemblyStatusId="+ON_PROGRESS, assembly,
            null, (res)=>{
                this.closePostProgress()
                if(isResponseOk(res)){
                    let assembly = res.data
                    this.props.onResult(assembly)
                }
            }, true, true)
    }

    render() {
        let {show, reference, model, assembly} = this.state
        if(!assembly){
            assembly = {}
        }
        let creator = assembly.creator?assembly.creator:{}
        let creatorManufacturingSite = creator.manufacturingSite?creator.manufacturingSite:{}
        let lastPerformer = assembly.user?assembly.user:{}
        let lastPerformerManufacturingSite = lastPerformer.manufacturingSite?lastPerformer.manufacturingSite:{}

        if(!model){
            model = {}
        }
        let modelCategory = model.modelCategory
        if(!modelCategory){
            modelCategory = {}
        }
        return (
            <>
                {super.render()}
                <Modal
                    as={Modal.Dialog}
                    size="md"
                    centered
                    show={show}
                    onHide={()=>{}}
                    onShow={()=>{
                        if(this.referenceInputRef && this.referenceInputRef.current){
                            this.referenceInputRef.current.focus()
                        }
                    }}>
                    <Modal.Header className="bg-light">
                        <Row className="p-0 m-0 d-block w-100">
                            <Col className="p-0 m-0 text-center d-block">
                                <h5 className="p-0 m-0 text-center d-block">{label.ContinueAssemblyConfirmation}</h5>
                            </Col>
                        </Row>
                    </Modal.Header>
                    <Modal.Body className="p-0">
                        <Row className="p-2">
                            <Col>
                                <Table responsive className="align-items-center table-flush p-0">
                                    <thead className="thead-light">
                                    <tr>
                                        <th scope="col">{label.Name}</th>
                                        <th scope="col">{label.Value}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td scope="row" >
                                            {label.Reference}
                                        </td>
                                        <td className='fw-bolder' style={{ whiteSpace: 'normal', wordWrap: 'break-word'}}>
                                            {reference}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td scope="row" >
                                            {label.ModelCategory}
                                        </td>
                                        <td className='fw-bolder' style={{ whiteSpace: 'normal', wordWrap: 'break-word'}}>
                                            {modelCategory.name}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td scope="row" >
                                            {label.Model}
                                        </td>
                                        <td className='fw-bolder' style={{ whiteSpace: 'normal', wordWrap: 'break-word'}}>
                                            {model.systemType}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td scope="row" >
                                            {label.ComponentSize}
                                        </td>
                                        <td className='fw-bolder' style={{ whiteSpace: 'normal', wordWrap: 'break-word'}}>
                                            {model.componentSize}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td scope="row" >
                                            {label.RectifierControllerSize}
                                        </td>
                                        <td className='fw-bolder' style={{ whiteSpace: 'normal', wordWrap: 'break-word'}}>
                                            {model.sizeOfRectifierControllerSerialNumber}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td scope="row" >
                                            {label.Creator}
                                        </td>
                                        <td className='fw-bolder' style={{ whiteSpace: 'normal', wordWrap: 'break-word'}}>
                                            {creator.firstname} / {creatorManufacturingSite.name} @{parseDate(assembly.created, DD_MMMM_YYYY_HH_MM_SS)}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td scope="row" >
                                            {label.LastPerformer}
                                        </td>
                                        <td className='fw-bolder' style={{ whiteSpace: 'normal', wordWrap: 'break-word'}}>
                                            {lastPerformer.firstname} / {lastPerformerManufacturingSite.name} @{parseDate(assembly.updated, DD_MMMM_YYYY_HH_MM_SS)}
                                        </td>
                                    </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        <hr className="p-0 m-0"/>
                        <Row className="p-3">
                            <Col className="text-right">
                                <ButtonGroup>
                                    <Button
                                        size="sm"
                                        variant="info"
                                        onClick={async (event) => {
                                            this.props.onClose()
                                        }}>
                                        {label.Cancel}&nbsp;&nbsp;<FontAwesomeIcon icon={faWindowClose}/>
                                    </Button>
                                    &nbsp;
                                    <Button
                                        size="sm"
                                        variant="danger"
                                        onClick={async (event) => {
                                            await this.submit()
                                        }}>
                                        {label.Continue}&nbsp;&nbsp;<FontAwesomeIcon icon={faSave}/>
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            </>
        );
    }

}
ContinueAssemblyConfirmationModal.propTypes = {
    show:PropTypes.bool.isRequired,
    model:PropTypes.object,
    assembly:PropTypes.object,
    reference:PropTypes.string,
    onClose:PropTypes.func.isRequired,
    onResult:PropTypes.func.isRequired
}

export default withRouter(ContinueAssemblyConfirmationModal)
